import { EnvironmentVariables } from '@/actions/config'

class Logger {
    public static envVariables: EnvironmentVariables
    private constructor() {}

    public static info = (message: unknown): void => this.log(() => console.info(message))
    public static warn = (message: unknown): void => this.log(() => console.warn(message))
    public static error = (message: unknown): void => this.log(() => console.error(message))

    /** Logs only if in development */
    private static log = (logFunction: Function): void => {
        if (!this.envVariables?.NEXT_PUBLIC_IS_DEVELOPMENT) return
        logFunction()
    }
}

export default Logger
